import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { useEffect, useMemo, useState } from 'react';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { InlineLabel } from 'foundations-components/transitional/components/InlineLabel';
import { isFailed, isLoading, isSucceeded } from 'reporting-data/asyncData/AsyncData';
import { DATASET_INSIGHT_TYPES } from 'reporting-data/tsTypes/datasetInsightTypes';
import { EVENTS } from 'reporting-ui-components/lib/events';
import useCloneTracker from 'reporting-ui-components/lib/useCloneTracker';
import { ADVANCED_INSIGHTS_UPGRADE_KEY } from '../../constants/datasetInsights';
import useFetchDatasetInsightTypeOptions from '../../hooks/useFetchDatasetInsightTypeOptions';
import useFetchUserInfo from '../../hooks/useFetchUserInfo';
import { disableDatasetInsights, enableDatasetInsightType, hasAdvancedInsightsAccess, reportHasDatasetInsightOptionType } from '../../lib/datasetInsightUtils';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const onChangeToggle = (isChecked, {
  onChange,
  report
}) => {
  const updatedReport = isChecked ? enableDatasetInsightType(report, DATASET_INSIGHT_TYPES.ANOMALY_DETECTION) : disableDatasetInsights(report, DATASET_INSIGHT_TYPES.ANOMALY_DETECTION);
  onChange(updatedReport);
};
export const AnomalyDetectionToggle = ({
  onChange,
  report,
  appUsageTracker,
  trackingAssetType,
  trackingApplicationName,
  trackingScreenName,
  inlineUse = false,
  onFailureToLoad
}) => {
  const isChecked = useMemo(() => {
    return reportHasDatasetInsightOptionType(report, DATASET_INSIGHT_TYPES.ANOMALY_DETECTION);
  }, [report]);
  const {
    openUpgradeModal
  } = useUpgradeModal(ADVANCED_INSIGHTS_UPGRADE_KEY);
  const [isAlreadyDisplayed, setIsAlreadyDisplayed] = useState(false);
  const userInfo = useFetchUserInfo();
  const hasAdvancedInsights = hasAdvancedInsightsAccess(userInfo === null || userInfo === void 0 ? void 0 : userInfo.user.scopes);
  const usageTracker = useCloneTracker(appUsageTracker);
  const fetchedInsightOptions = useFetchDatasetInsightTypeOptions(report);
  const isNotValidInisght = isSucceeded(fetchedInsightOptions) && !fetchedInsightOptions.data.some(option => option.value === DATASET_INSIGHT_TYPES.ANOMALY_DETECTION);
  const shouldNotRenderComponent = isFailed(fetchedInsightOptions) || isNotValidInisght;
  useEffect(() => {
    if (!isLoading(fetchedInsightOptions)) {
      if (isNotValidInisght) {
        setIsAlreadyDisplayed(false);
      } else {
        setIsAlreadyDisplayed(true);
      }
    }
  }, [fetchedInsightOptions, isAlreadyDisplayed, isNotValidInisght]);
  useEffect(() => {
    if (shouldNotRenderComponent) {
      onFailureToLoad === null || onFailureToLoad === void 0 || onFailureToLoad();
    }
  }, [shouldNotRenderComponent, onFailureToLoad]);
  if (isLoading(fetchedInsightOptions) && !isAlreadyDisplayed || shouldNotRenderComponent) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  const trackToggle = toggleValue => {
    const trackerProps = {
      action: toggleValue ? 'enable' : 'disable',
      value: DATASET_INSIGHT_TYPES.ANOMALY_DETECTION
    };
    usageTracker.track(EVENTS.toggleDatasetInsights, Object.assign({}, trackerProps, {
      assetType: trackingAssetType || 'report',
      applicationName: trackingApplicationName,
      whereScreen: trackingScreenName
    }));
  };
  return /*#__PURE__*/_jsx(InlineLabel, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "report-customization-components.customization-components.datasetInsightTypes.ANOMALY_DETECTION"
    }),
    typography: !inlineUse ? 'heading-50' : undefined,
    inlineSize: !inlineUse ? '100%' : undefined,
    children: /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      justify: "between",
      children: [/*#__PURE__*/_jsx(TFlex, {
        align: "center",
        justify: "start",
        children: /*#__PURE__*/_jsx(HelpIcon, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "report-customization-components.customization-components.datasetInsightTypesHelpText.ANOMALY_DETECTION"
          }),
          marginInlineEnd: "200"
        })
      }), /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        justify: "end",
        children: [!isNotValidInisght && !hasAdvancedInsights && /*#__PURE__*/_jsx(LockBadge, {
          marginBlockStart: "100",
          marginInlineEnd: "200"
        }), /*#__PURE__*/_jsx(Toggle, {
          "data-test-id": "anomaly-detection-toggle-element",
          size: "extra-small",
          checked: isChecked,
          disabled: isLoading(fetchedInsightOptions) && isAlreadyDisplayed,
          onChange: ({
            target: {
              checked: newValue
            }
          }) => {
            if (!hasAdvancedInsights) {
              openUpgradeModal();
              return;
            }
            trackToggle(newValue);
            onChangeToggle(newValue, {
              onChange,
              report
            });
          }
        })]
      })]
    })
  });
};